var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiquide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51.83 82.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:.75px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m36.49,66.47c2.37.69,3.81,1.61,3.81,2.62,0,2.14-6.47,3.87-14.45,3.87s-14.45-1.73-14.45-3.87c0-.81.94-1.57,2.54-2.19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m41.92,64.98c2.94,1.12,4.69,2.55,4.69,4.11,0,3.6-9.38,6.51-20.96,6.51s-20.96-2.92-20.96-6.51c0-1.41,1.45-2.72,3.91-3.79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.27,11.96l-6.3,12.94c-2.17,6.04-8.61,16.79-8.44,22.29.28,9.43,7.93,17.27,17.36,17.76,10.58.55,19.33-7.86,19.33-18.32,0-5.68-7-17.14-10.38-23.66L25.15,6.07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiquide);
export default __webpack_public_path__ + "static/media/LIQUIDE.c840005b64d1c3858312fbec0f237b60.svg";
export { ForwardRef as ReactComponent };